import { atomFamily, selectorFamily } from 'recoil'
import { IAccount, UserId } from '../types/types'
import { api } from '../utils/api'

export const fetchUserAccounts = async (userId: string): Promise<IAccount[]> => {
  const { data } = await api.get(`/user/${userId}/accounts`)
  return data.accounts
}

export const userAccountsState = atomFamily<IAccount[], UserId>({
  key: 'userAccountsState',
  default: selectorFamily({
    key: 'userAccountsState/Default',
    get: (userId: UserId) => async (): Promise<any[]> => fetchUserAccounts(userId),
  }),
})